import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: "removeSpaces",
  standalone: false,
})
export class RemoveSpacesPipe implements PipeTransform {
  constructor() {}
  transform(string) {
    return string.replace(/\s/g, "");
  }
}
